module.exports = __webpack_public_path__ + "static/media/12.423f335a.jpg";